import ESTIMATE_CONSTANT from "../../../constant/estimateConstant"
import { isBuildUp, isMetal, isRigid } from "../../../service/oneClickIs"
import type EstimateValues from "../../../types/params"

const isValidResistColor = (values: EstimateValues, resistColor?: string) => {
  switch (resistColor) {
    case ESTIMATE_CONSTANT.レジスト色["緑(リジッド)"].value:
    case ESTIMATE_CONSTANT.レジスト色["赤(リジッド)"].value:
    case ESTIMATE_CONSTANT.レジスト色["青(リジッド)"].value:
    case ESTIMATE_CONSTANT.レジスト色["黄(リジッド)"].value:
    case ESTIMATE_CONSTANT.レジスト色["白(リジッド)"].value:
    case ESTIMATE_CONSTANT.レジスト色["黒(リジッド)"].value:
    case ESTIMATE_CONSTANT.レジスト色["黒（つや消し）(リジッド)"].value:
      return isRigid(values)
    case ESTIMATE_CONSTANT.レジスト色.紫.value:
      return isRigid(values) && !isBuildUp(values)

    case ESTIMATE_CONSTANT.レジスト色["緑(メタル)"].value:
    case ESTIMATE_CONSTANT.レジスト色["赤(メタル)"].value:
    case ESTIMATE_CONSTANT.レジスト色["青(メタル)"].value:
    case ESTIMATE_CONSTANT.レジスト色["黄(メタル)"].value:
    case ESTIMATE_CONSTANT.レジスト色["白(メタル)"].value:
    case ESTIMATE_CONSTANT.レジスト色["黒(メタル)"].value:
    case ESTIMATE_CONSTANT.レジスト色["黒（つや消し）(メタル)"].value:
      return isMetal(values)

    default:
      return false
  }
}

export default isValidResistColor
